




































import Vue from 'vue'
import Datepicker from 'vuejs-datepicker'
import dayjs from 'dayjs'

export default Vue.extend({
  name: 'DatePicker',
  components: {
    Datepicker
  },
  props: {
    value: {
      type: String
    },
    label: {
      type: String,
      default: null
    },
    errorMessages: {
      type: Array,
      default: null
    },
    disabledDates: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    top: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number,
      default: null
    },
    sampleProperty: {
      type: String,
      default: null
    },
  },
  data(): {
    date: string | null;
    pickerDate: any;
  } {
    return {
      date: this.value ? dayjs(this.value).format('YYYY-MM-DD') : null,
      pickerDate: null
    }
  },
  watch: {
    value: {
      handler() {
        this.date = this.value ? dayjs(this.value).format('YYYY-MM-DD') : null

        this.changePickerDate()
      }
    },
    pickerDate() {
      this.date = this.pickerDate ? dayjs(this.pickerDate).format('YYYY-MM-DD') : null
      this.$emit('input', this.date)
      //this.$emit('change' , this.date)
    }
  },
  methods: {
    changePickerDate(): void {
      if (this.date !== null && this.date !== undefined) {
        this.pickerDate = dayjs(this.date).toDate()
      } else {
        this.pickerDate = null
      }
    }
  },
  computed: {
    style(): string {
      if (this.maxWidth) {
        return `max-width:${this.maxWidth}px;display: inline-block;`
      }

      return ''
    },
    classNames(): string {
      let classList = [] as string[]

      this.top && classList.push('class-top')

      !this.hideDetails && classList.push('calendar-offset')

      return classList.join(' ')
    }
  },
})
